export default (state = {}, {openPeriodId}: any) => {
  return {
    ...state,
    openPeriodId,
  };
};
